export const G2_LAST_VIEWED_COOKIE_NAME = "g2_last_viewed";
export const G2_LAST_VIEWED_COOKIE_MAX_AGE = 60 * 60 * 24 * 14; // 14 days
